<template>
  <v-layout row wrap>
    <v-flex xs12 md6>
      <v-card>
        <v-card-title>
          <div>
            <h1 class="title">Password</h1>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <form @submit.prevent="formSubmit">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field required name="newPassword" label="New password" v-model="user.new_password" v-validate="'required|min:6'" :error-messages="errors.collect('new password')" data-vv-name="new password" :append-icon="e2 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e2 = !e2)" :type="e2 ? 'password' : 'text'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field required label="Password confirmation" v-model="user.retype_password" v-validate="'required|confirmed:newPassword|min:6'" :error-messages="errors.collect('password confirmation')" data-vv-name="password confirmation" :append-icon="e3 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e3 = !e3)" :type="e3 ? 'password' : 'text'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <div>
                      <span class="caption">*After password reset, the new password will be effective next time user login.</span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn to="/approver">cancel</v-btn>
              <v-btn dark color="accent" @click="formSubmit" :loading="getLoading" :disable="getLoading">change password
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-card>
    </v-flex>
    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ChangeApproverPassword',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      id: this.$route.params.id,
      e2: true,
      e3: true,
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      user: {
        new_password: '',
        retype_password: ''
      }
    }
  },
  computed: {
    ...mapGetters(['getLoading', 'getResponse'])
  },
  methods: {
    ...mapActions(['changeApprovalPassword', 'signOut']),
    formSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let payload = {
            id: this.id,
            user: this.user
          }
          this.changeApprovalPassword(payload).then(() => {
            let response = this.getResponse
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Changed successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/mobile-user/ChangeApproverPassword.vue